"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var getEditorClass = function getEditorClass(styleClasses, name, defaultName) {
	if (styleClasses && name) {
		return styleClasses[name];
	}
	if (styleClasses && !name) {
		return styleClasses[defaultName];
	}
};

exports["default"] = getEditorClass;
module.exports = exports["default"];
